export const GAM_TEMPORARY_ERROR = 'GAM_TEMPORARY_ERROR';
export const GAM_SYSTEM_ERROR = 'GAM_SYSTEM_ERROR';
export const ICC_TEMPORARY_ERROR = 'ICC_TEMPORARY_ERROR';
export const UAM_TEMPORARY_ERROR = 'UAM_TEMPORARY_ERROR';
export const CM_TEMPORARY_ERROR = 'CM_TEMPORARY_ERROR';
export const ICC_UNAVAILABLE_ERROR = 'ICC_UNAVAILABLE_ERROR';
